import React from 'react'

const ItemTooltip = ({icon, value}) => (
  <div className="flex items-center gap-3">
    {icon}
    <span className="text-2xs text-color-300 lowercase italic whitespace-no-wrap">
      {value}
    </span>
  </div>
)

export default ItemTooltip
